
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CoursePayload } from '@/modules/learning/learning.model'
import { mapActions, mapState } from 'vuex'
import Notification from "@/modules/common/services/notification.service";
import Container from "typedi";

@Component({
  computed: {
    ...mapState('learning', ['chapters'])
  },
  methods: {
    ...mapActions('learning', ['getCourse', 'getChapters'])
  }
})
export default class ChapterIndexView extends Vue {
  @Prop({ required: true }) readonly course_uuid!: string;

  getCourse!: (payload: CoursePayload) => Promise<any>
  getChapters!: (payload: CoursePayload) => Promise<any>
  chapters!: any[]

  get isChaptersView () {
    return this.$route.name === 'learning.chapters'
  }

  async mounted () {
    try {
      // await this.getCourse({ course_uuid: this.course_uuid })
      await this.getChapters({ course_uuid: this.course_uuid })
    } catch (error) {
      Container.get(Notification).error("There was an error fetching chapters.")
    }
  }
}
